import { render, staticRenderFns } from "./GenericVettingForm.vue?vue&type=template&id=354dcd8a&"
import script from "./GenericVettingForm.vue?vue&type=script&lang=js&"
export * from "./GenericVettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports